import { useEffect, useState } from "react";
import { Armchair, BadgeCheck } from "lucide-react";
import api from "../../lib/api";

/* Lounge Finder — lounges at a connection airport ranked by YOUR saved access
   programs (My Lounge Access) and loyalty alliances. Used in the Airport Transit Guide. */
export default function LoungeSuggest({ airport }) {
  const [data, setData] = useState(null);
  const iata = ((airport || "").match(/\b[A-Z]{3}\b/) || [])[0];
  useEffect(() => {
    if (iata) api.get(`/lounge-finder/${iata}`).then((r) => setData(r.data)).catch(() => {});
  }, [iata]);
  if (!iata || !data || (!data.matched.length && !data.others.length)) return null;
  return (
    <div className="mt-2 border-t border-current/20 pt-2" data-testid={`lounge-suggest-${iata}`}>
      <div className="font-700 flex items-center gap-1.5"><Armchair className="w-3.5 h-3.5" /> Lounges at {iata} during your layover</div>
      {data.matched.length > 0 ? (
        <ul className="mt-1 space-y-1 font-normal">
          {data.matched.slice(0, 4).map((l) => (
            <li key={l.id} className="flex items-start gap-1.5">
              <BadgeCheck className="w-3.5 h-3.5 mt-px shrink-0 text-emerald-600" />
              <span><b>{l.name}</b>{l.terminal ? ` · ${l.terminal}` : ""} — {l.access_reasons[0]}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="mt-1 font-normal">
          {data.has_programs
            ? `No lounge here matches your saved programs — ${data.others.length} other lounge${data.others.length > 1 ? "s" : ""} available (day passes may be an option).`
            : "Save your lounge programs & airline status in My Travel Hub to see which of these you can enter."}
        </p>
      )}
      <a href={`/airports/${iata}`} className="inline-block mt-1 font-700 underline">All {iata} lounges &amp; amenities →</a>
    </div>
  );
}
